import { IconAngleRight, IconBank, IconCreditCardFilled } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export const QuickLinks = () => (
    <div className="w-full">
        <Text className="mb-m text-l font-bold">
            <FormattedMessage
                id="_.credit_card.dashboard.quick_links"
                defaultMessage="Manage my account"
            />
        </Text>

        <div className="flex flex-col gap-0">
            {/* Change payment details */}
            <Link to={{ pathname: '' }}>
                <div className="flex w-full flex-row items-center justify-between border-b border-secondary-90 py-l hover:no-underline">
                    <div className="flex flex-row gap-m">
                        <IconBank className="fill-primary-10" />
                        <Text className="text-s font-med">
                            <FormattedMessage
                                id="_.credit_card.dashboard.change_payment_details"
                                defaultMessage="Change payment details"
                            />
                        </Text>
                    </div>
                    <IconAngleRight className="fill-primary-10" />
                </div>
            </Link>

            {/* Account preferences */}
            <Link to={{ pathname: '' }}>
                <div className="flex w-full flex-row items-center justify-between border-b border-secondary-90 py-l hover:no-underline">
                    <div className="flex flex-row gap-m">
                        <IconCreditCardFilled className="my-auto fill-primary-10" />
                        <Text className="text-s font-med">
                            <FormattedMessage
                                id="_.credit_card.dashboard.account_preferences"
                                defaultMessage="Account preferences"
                            />
                        </Text>
                    </div>
                    <IconAngleRight className="fill-primary-10" />
                </div>
            </Link>
        </div>
    </div>
);
